import React from 'react';
import { styled } from '@compiled/react';
import { type Size, sizes } from '@atlaskit/icon';
import { useThemeObserver } from '@atlaskit/tokens';
import ComponentTypesMetadata from '../../../common/ui/component-types-metadata/index.tsx';

type ComponentIconBackgroundProps = {
	testId?: string;
	type: keyof typeof ComponentTypesMetadata;
	size?: Size;
	children?: React.ReactNode;
};

export function ComponentIconBackground(props: ComponentIconBackgroundProps) {
	const { type, size = 'medium', testId, children } = props;

	const { colorMode } = useThemeObserver();
	const isDarkMode = colorMode === 'dark';

	return (
		<IconBackground
			data-testid={testId}
			size={size}
			color={ComponentTypesMetadata[type].color(isDarkMode)}
		>
			{children}
		</IconBackground>
	);
}

type IconBackgroundProps = {
	size: Size;
	color: string;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconBackground = styled.div<IconBackgroundProps>({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	width: (props) => sizes[props.size],
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	height: (props) => sizes[props.size],

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) => props.color,
	borderRadius: '3px',

	// The ComponentIconGlyph is typically placed inside this background and uses
	// the same standard AtlasKit sizes. We need to shrink it so that it's not
	// flush to the edges of this background.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"& > svg, & > span[role='img'], & > span[role='presentation']": {
		width: '83.333333%',
	},
});
